export default __webpack_public_path__ + "static/media/mute-all-new.be3b8a2b.svg";